"use client";

import { HmcButton } from "@adi-ctx/harmonic-core-components-react";

/**
 * Override the original Harmonic Button component
 * so that it can be used in server components as well
 * @constructor
 */
export default function Button({ children, ...props }: Record<string, any>) {
	return <HmcButton {...props}>{children}</HmcButton>;
}
